import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getBot } from 'src/actions/botsActions';

function LiveChatLayout({ children }) {
  const { botId } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBot(botId));
  }, [dispatch, `${botId}`]);
  return <>{children}</>;
}

LiveChatLayout.propTypes = {
  children: PropTypes.any
};

export default LiveChatLayout;
